import React, {PureComponent} from 'react';
import {withTranslation} from 'react-i18next';
import {Card, CardBody, CardTitle, Row} from 'reactstrap';
import {Colxx} from '../components/common/CustomBootstrap';
import {NotificationManager} from '../components/common/react-notifications';
import LoaderButton from '../components/LoaderButton';
import {reactTableText} from '../constants/configs';
import Rbac from '../components/Rbac';
import ReactTable from 'react-table';
import {keyBy, filter} from 'lodash';
import Api from '../services/Api';

class NetworksAddresses extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      networks: [],
      generating: {},
      addresses: {},
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    try {
      await Promise.all([
        this.fetchNetworks(),
        this.fetchNetworksAddresses()
      ]);
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  fetchNetworks = async () => {
    try {
      const {data} =  await Api.invoke('GET', '/networks');
      this.setState({
        networks: filter(data, network => network.name !== 'BANK' && network.name !== 'ID_BASED_PAYMENT'),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchNetworksAddresses = async () => {
    const {userId} = this.props;
    try {
      const {data} =  await Api.invoke(
        'GET',
        '/admin-ui/networks-addresses',
        null,
        {
          params: {
            userId,
          },
        },
      );
      this.setState({
        addresses: keyBy(data, 'name'),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  generateAddress = async network => {
    const {t, userId} = this.props;
    this.setState(({generating}) => ({
      generating: {
        ...generating,
        [network]: true,
      },
    }));
    try {
      await Api.invoke('POST', '/admin-ui/network-address', {
        userId,
        network,
      });
      NotificationManager.success(t('Wallet address generated successfully'), t('Message'));
      await this.fetchNetworksAddresses();
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState(({generating}) => ({
        generating: {
          ...generating,
          [network]: false,
        },
      }));
    }
  };

  getColumns = () => {
    const {t} = this.props;
    const {addresses, generating} = this.state;
    return [
      {
        Header: t('Network'),
        accessor: 'localeName',
        width: 300,
      },
      {
        Header: t('Main Address'),
        accessor: 'name',
        Cell: props => {
          if (addresses[props.value]) {
            return (
              <span>{addresses[props.value].mainAddress}</span>
            );
          }
          return null;
        },
      },
      {
        Header: t('Tag Address'),
        accessor: 'name',
        width: 200,
        Cell: props => {
          if (addresses[props.value]) {
            return (
              <span>{addresses[props.value].extraAddress}</span>
            );
          }
          return null;
        },
      },
      {
        Header: t('Actions'),
        accessor: 'name',
        width: 140,
        Cell: props => {
          if (!addresses[props.value]) {
            return (
              <LoaderButton
                color="success"
                className="text-center"
                style={{minWidth: '100px'}}
                loading={!!generating[props.value]}
                disabled={!!generating[props.value]}
                onClick={async () => {await this.generateAddress(props.value);}}
              >
                {t('Generate Address')}
              </LoaderButton>
            );
          }
          return null;
        },
        show: Rbac.hasPermission('create_network-address'),
      }
    ];
  }

  render() {
    const {t} = this.props;
    const {networks, loading} = this.state;
    return (
      <Row>
        <Colxx xxs="12" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-4">
                {t('Wallets Addresses')}
              </CardTitle>
              <ReactTable
                manual
                className="-highlight"
                data={networks}
                loading={loading}
                sortable={false}
                resizable={true}
                showPagination={false}
                columns={this.getColumns()}
                defaultPageSize={networks.length}
                style={{
                  width: '100%'
                }}
                {...reactTableText}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(NetworksAddresses);
